<template>
  <div id="app" :class="[ popupActive ? 'popup-active' : '', 'lang-'+state.lang]">
    <div class="wrapper">
      <header>
        <NavigationMenu></NavigationMenu>
        <Hero></Hero>
      </header>

      <div class="section section--products">
        <div class="container">
          <h2 class="heading" v-html="texts.title"></h2>
          <ProductSort :tags="tags.tags" v-on:tagSelected="filterOutProducts" :sortLabel="texts.label"></ProductSort>
          <Products :products="visibleProducts"></Products>
        </div>
      </div>

      <div class="section section--order" :class="[showMessageStatus ? 'message-status-active' : '']">
        <div class="container">
          <transition-group name="fade">
            <OrderCard
              v-if="showOrderCard"
              :key="orderType"
              :prod="orderProduct"
              :orderType="orderType"/>
          </transition-group>
        </div>
      </div>

      <div class="message-status" v-if="showMessageStatus">
        <div class="close-cross" @click="closeOrder"></div>
        <div class="message-status__text" v-html="messageStatusText"></div>

      </div>

    <!-- wrapper -->
    </div>

    <FooterMenu></FooterMenu>
    <sendAnimation v-if="sendInProgress"></sendAnimation>
    <div class="footer__sticky" v-if="!showOrderCard && !showFeedbacks">
      <div class="footer__sticky-wrapper">
        <div class="footer__sticky-tagline" v-html="footerText.aLook"></div>
        <button name="TryButton" @click="tryProduct" class="footer__sticky-try button--rounded">{{footerText.order}}</button>
      </div>
    </div>

  </div>
</template>

<script>
import normalize from 'normalize.css';

import HelloWorld from './components/HelloWorld.vue';

import OrderCard from './components/OrderCard.vue';
import Products from './components/Products.vue';
import NavigationMenu from './components/UIComponents/NavigationMenu.vue';
import Hero from './components/UIComponents/Hero.vue';
import ProductSort from './components/UIComponents/ProductSort.vue';
import FooterMenu from './components/UIComponents/FooterMenu.vue';
import sendAnimation from './components/UIComponents/sendAnimation.vue';

export default {
  name: 'app',
  data() {
    return {}
  },
  components: {
    HelloWorld,
    OrderCard,
    NavigationMenu,
    Hero,
    ProductSort,
    FooterMenu,
    Products,
    sendAnimation,
  },
  computed: {
    state() {
      return this.$root.$data.state;
    },
    showMessageStatus() {
      return this.state.showMessageStatus;
    },
    messageStatusText() {
      return this.state.messageStatusText;
    },
    sendInProgress() {
      return this.state.sendInProgress;
    },
    tags() {
      return this.state.tags;
    },
    popupActive() {
      return this.state.popupActive;
    },
    showOrderCard() {
      return this.state.showOrderCard;
    },
    showFeedbacks() {
      return this.state.showFeedbacks;
    },
    orderType() {
      return this.state.orderType;
    },
    orderProduct() {
      return this.state.orderProduct;
    },
    products() {
      return this.state.products;
    },
    visibleProducts() {
      const sortBy = this.state.sort;
      console.log(sortBy);
      if ( sortBy.includes('view all') || sortBy.includes('skatīt visus'))  {
        return this.products;
      }
      // Filter out courses by selected tags
      return this.products.filter(prod => prod.tags.some(el => sortBy.includes(el)) );
    },
    texts() {
      return this.state.system.main
    },
    footerText() {
      return this.state.system.footer
    },
  },
  methods: {
    closeOrder() {
      this.$root.$data.state.showMessageStatus = false;
      this.$root.$data.hideOrder();
    },
    tryProduct() {
      console.log('try product pressed');
      this.$root.$data.showOrder({ orderType: 'multiple' });
    },
    /**
     * @description select tags which will sort out the courses
     * @param {array} tag the tag to toggle.
     * @return {undefined} function does not return anything, we just modify [sort] array.
     */
    filterOutProducts(tag) {
      console.log(`will sort out products with a ${tag} tag in mind`);
      if ( tag === 'view all' ) {
        this.$root.$data.state.sort = ['view all'];
        return;
      } else if (tag === 'skatīt visus') {
        this.$root.$data.state.sort = ['skatīt visus'];
        return
      } else {
        let locationOfAll = this.$root.$data.state.sort.indexOf('skatīt visus');
        locationOfAll >= 0 ? this.$root.$data.state.sort.splice(locationOfAll, 1) : true;
        locationOfAll = this.$root.$data.state.sort.indexOf('view all');
        locationOfAll >= 0 ? this.$root.$data.state.sort.splice(locationOfAll, 1) : true;
      }
      const tagId = this.$root.$data.state.sort.indexOf(tag);
      console.log(tagId);
      tagId >= 0 ? this.$root.$data.state.sort.splice(tagId, 1)
                 : this.$root.$data.state.sort.push(tag)
    }
  }
};
</script>

<style lang="stylus">

@import url('https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700&amp;subset=cyrillic')
@import './styles/reset.styl'
@import './styles/common.styl'

*
*:before
*:after
  box-sizing border-box

html
  height 1500px
  background-color $OTSbg

#app
  font-family 'Open Sans', Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  background-color $OTSbg
  &.popup-active
    &:after
      content ''
      position fixed
      height 100%
      width 100%
      left 0px
      top 0px
      background-color $OTSnavBlue
      opacity 0.7

.container
  margin 0 auto
  max-width 996px
  height 100%

  .heading
    text-transform uppercase
    font-size 38px
    font-weight 600
    text-align center
    padding-top 70px
    padding-bottom 50px
    color #333333


.section
  &--products
    margin-bottom 85px
  &--order
    &.message-status-active
      &:after
        content ''
        position fixed
        display block
        height 100%
        width 100%
        background-color $OTSnavBlue
        top 0px
        z-index 90
        opacity 0.7


body
  +mobile()
    padding-bottom 0px
  +mobileXS()
    padding-bottom 10px
  +desktopH()
    padding-bottom 855px
.wrapper
  position relative
  background $OTSbg
  z-index 10
  box-shadow 0 0 10px rgba(#FFF,.5)
  .message-status
    position fixed
    top 0px
    bottom 0px
    left 0px
    right 0px
    margin auto
    background-color #f6f6f6
    border-radius 4px
    width 100%
    max-width 420px
    height 160px
    text-align center
    padding 20px
    z-index 100
    display flex
    justify-content center
    align-items center
    h2
      font-weight 600
    &__text
      line-height 1.4em

.footer
  z-index 5
  height auto
  position static
  +desktopH()
    position fixed
    bottom 0px
    left 0px
    right 0px
    height 770px

  .container
    height calc(100% - 40px)
  &__sticky
    position fixed
    bottom 0px
    height 85px
    width 100%
    text-align center
    background-image url('./assets/hero.jpg')
    background-repeat no-repeat
    background-position 0% 45%
    background-size cover
    z-index 15
    +mobile()
      height 85px
    +mobileXS()
      height 95px
    &-wrapper
      display inline-block
      height 100%
      vertical-align middle
      line-height 85px
      +mobile()
        line-height 40px
        display flex
        justify-content space-around
        align-items center
        flex-flow column
    &-tagline
      display inline-block
      font-size 20px
      color #fff
      font-weight 300
      +mobile()
        font-size 16px
        line-height 1.4
        margin-top 6px
        display block
      +mobileXS()
        float left
        width 100%
        margin-bottom 0

    &-try
      display inline-block
      padding 15px 30px
      text-transform uppercase
      font-weight 300
      background-color $OTSred
      border none
      color #fff
      margin-left 30px
      &:hover
        background-color darken($OTSred, 10%)
      +mobile()
        display block
        margin 0 auto
        font-size 14px
        padding 10px
      +mobileXS()
        margin-bottom 6px

.lang-lv
  .orders
    &__left-block
      .tags
        .tag
          text-transform none
          &::first-letter
            text-transform uppercase
      .select-products
        &__product
          label
            text-transform none
            &::first-letter
              text-transform uppercase
    &__right-block
      .select-products
        &__product
          label
            text-transform none
            &::first-letter
              text-transform uppercase
  .product
    &__title
      text-transform none
      &::first-letter
        text-transform uppercase
</style>



// WEBPACK FOOTER //
// src/App.vue